<template>
  <div class="row">
    <div class="col-sm-12 cart-items">
      <div
        class="cart-item-qty inline-group input-group"
        v-show="!cartItem.reedemptionRule"
      >
        <div v-if="removeButton" class="input-group-prepend">
          <button
            @click.prevent="stepdown"
            class="btn btn-outline-secondary btn-minus"
            :disabled="isDisabled"
          >
            <i :style="desktopStyles.textColour" class="fa fa-minus"></i>
          </button>
        </div>
        <input
          @input="updateQt($event)"
          ref="quantity"
          class="form-control quantity"
          min="1"
          name="quantity"
          :value="cartItem.quantity"
          type="number"
          readonly
        />
        <div v-if="removeButton" class="input-group-append">
          <button
            @click.prevent="stepup"
            class="btn btn-outline-secondary btn-plus"
          >
            <i class="fa fa-plus" :style="desktopStyles.textColour"></i>
          </button>
        </div>
        <div class="cart-qty-empty" v-if="cartItem.reedemptionRule"></div>
      </div>
      <div class="cart-item-details">
        <div
          class="item-details-name"
          :class="cartItem.unavailable ? 'text-line-through' : ''"
        >
          {{ cartItem.name }}
        </div>
        <ul v-if="cartItem.modifiers">
          <li
            v-for="(md, i) in cartItem.modifiers"
            :key="md.ID + '_' + cartItem.uniqueId + '_' + i"
          >
            {{ md.Name }} ({{ md.quantity }})
            <ul
              v-if="
                md.selectedSubmodifiers && md.selectedSubmodifiers.length > 0
              "
            >
              <li
                v-for="(submd, j) in md.selectedSubmodifiers"
                :key="submd.ID + '_' + cartItem.uniqueId + '_' + j"
              >
                {{ submd.Name }} ({{ md.quantity * submd.quantity }})
              </li>
            </ul>
          </li>
          <li :style="desktopStyles.textColour">
            {{ cartItem.itemNote }}
          </li>
        </ul>
        <div v-if="this.removeButton">
          <a
            v-if="!cartItem.unavailable"
            :style="desktopStyles.LinkColorTxt"
            href="#"
            @click.prevent="removeCartItem(cartItem)"
            >{{ $t("message.remove") }}</a
          >
        </div>
        <span class="soldout" v-if="cartItem.soldout"
          >({{ $t("message.soldOut") }})</span
        >
        <span class="soldout" v-if="cartItem.unavailable"
          >({{ $t("message.unavailable") }})</span
        >
      </div>
      <div
        v-if="!discount"
        class="cart-item-cost"
        :class="cartItem.unavailable ? 'text-line-through' : ''"
      >
        {{ price | formatMoney(currencySign) }}
      </div>
      <div
        class="cart-item-cost"
        v-else
        :class="cartItem.unavailable ? 'text-line-through' : ''"
      >
        <del>{{ price | formatMoney(currencySign) }}</del>
        <span>{{ discount | formatMoney(currencySign) }}</span>
      </div>
      <div
        v-if="getPoints"
        class="item-points text-success"
        v-show="this.applicableLoyalityRule.length === 1"
        :class="cartItem.unavailable ? 'text-line-through' : ''"
      >
        <span v-if="(storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints) || enableStamps">
          ({{ Math.floor(getPoints) | formatNumber }}
          {{ loyaltyUnit(Math.floor(getPoints)) }})
        </span>
      </div>
    </div>
    <div class="col-sm-12 cart-items" v-if="rollInto">
      <a
        v-for="rt in rollInto.selectedRollIntos"
        :key="rt.ID"
        class="run-into-meal-btn"
        @click="editRollInto(rt)"
      >
        <div :style="rollIntoButtonClassNames(rt)">
          <div class="col-sm-12 roll-into-items">
            <div class="roll-item-details">
              <div class="roll-item-details-name">{{ rollInto.Name }}</div>
              <ul>
                <li v-for="md in rt.selectedModifiers" :key="md.ID">
                  {{ md.Name }} ({{ md.quantity }})
                </li>
              </ul>
            </div>
            <div
              v-if="getRollIntoPoints(rt)"
              class="roll-item-point-shoppingcart"
            >
              ({{ Math.floor(getRollIntoPoints(rt)) | formatNumber }} pts)
            </div>

            <div
              v-if="rt.isConfirmed"
              :class="getRollIntoPoints(rt) ? 'has-point' : ''"
              class="roll-item-cost"
            >
              {{ rt.appliedDiscount | formatMoney(currencySign) }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <modal
      ref="rollIntoModal"
      v-if="showRollInto"
      full-header
      @close="closeModal"
      @open="openModal()"
      hide-footer
      height="500px"
      style="z-index: 10"
    >
      <template slot="body">
        <div
          style="
            max-height: calc(70vh);
            min-height: 200px;
            overflow-y: auto;
            margin-bottom: 50px;
          "
        >
          <Modifiers
            :price-trigger="rollInto"
            @canceled="closeModal"
            :product="rollIntoParams.product"
            :modifiers="rollIntoParams.modifiers"
            :product-id="rollIntoParams.productId"
            @updated="selectRollIntoModiefiers"
            :initial-modifiers="initialModifier(selectedIndex)"
            :rollinto-index="selectedIndex"
            :is-submodifier="true"
            :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/shopping-cart/CartItem.js";
import { priceTriggerType } from "../../../api/constants/priceTriggerEnums";
import { mapGetters } from "vuex";
import modal from "../../modal";
import Modifiers from "../products/Modifiers.vue";
export default {
  components: {
    modal,
    Modifiers,
  },
  props: {
    cartItem: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => {},
    },
    removeButton: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      qtyNumbers: [],
      showRollInto: false,
      selectedRollIntoModiefiers: [],
    };
  },
  watch: {
    "cartItem.quantity": function () {
      if (this.rollInto) {
        this.fixRollIntoQuantity();
      }
    },
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "desktopStyles",
      "storeMenu",
      "getPriceTriggerOutcomes",
      "canshowRollInto",
      "applicableLoyalityRule",
      "storeSupportEarningLoyaltyPoints"
    ]),
    isDisabled() {
      return this.cartItem.quantity == 1;
    },
    showRollIntoProduct() {
      return this.canshowRollInto({
        ...this.menuCopy.Products[this.cartItem.id],
        quantity: this.cartItem.quantity,
        index: this.rollInto.selectedRollIntos.length,
      });
    },
    rollInto() {
      var result = this.getPriceTriggerOutcomes.find(
        (oc) =>
          oc.order == this.cartItem.uniqueId &&
          oc.type == priceTriggerType.rollIntoMealPriceTriggers
      );
      if (result && !result.selectedRollIntos) {
        result.selectedRollIntos = [];
      } else if (result) {
        const confirmedOne = result.selectedRollIntos.find((element) => {
          return (
            element.isConfirmed ||
            (element.selectedModifiers && element.selectedModifiers.length > 0)
          );
        });

        if (!confirmedOne) {
          result.selectedRollIntos.splice(1);
        }
      }

      return result;
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    rollIntoParams() {
      return {
        product:
          this.menuCopy.Products[this.rollInto.rollIntoProduct.ProductID],
        modifiers: this.menuCopy.ModifierGroups,
        productId: this.rollInto.rollIntoProduct.ProductID,
      };
    },
  },
  created() {
    shared.createdComponent(this);
  },
  methods: {
    ...shared.methods,
    openModal() {
      if (this.isWC()) this.$emit("change-sticky", true);
    },
    stepup() {
      this.$refs.quantity.stepUp();
      this.updateQt(this.$refs.quantity.value);
    },
    stepdown() {
      if (this.$refs.quantity.value > 1) {
        this.$refs.quantity.stepDown();
        this.updateQt(this.$refs.quantity.value);
      }
    },
  },
};
</script>
